import { useEffect } from "react";

import { UbpContextProvider } from "@/components/usage-based-pricing-calculator/src/context";
import {
    useLoadProductCatalogData,
    useIsProductCatalogDataReady,
    useProductCatalogData
} from "@/components/usage-based-pricing-calculator/src/hooks";
import { PricingPageLayout } from "@/components/wpl/pricing/src/pricing-page-layout";
import { GlobalNav } from "@/patterns/global-nav/src";

export const UsageBasedPricingPage = () => {
    return (
        <PricingPageLayout nav={<GlobalNav productKey="usage-based-pricing" />}>
            <UbpContextProvider>
                <UsageBasedPricing />
            </UbpContextProvider>
        </PricingPageLayout>
    );
};

const UsageBasedPricing = () => {
    const loadData = useLoadProductCatalogData();

    useEffect(() => {
        void loadData();
    }, []);

    const isReady = useIsProductCatalogDataReady();
    const data = useProductCatalogData();

    {
        /* TODO GWP-11099 replace with UI */
    }
    if (!isReady) return <p>LOADING...</p>;
    return (
        <div>
            <pre>{JSON.stringify(data, null, 2)}</pre>
        </div>
    );
};
